<script>
import request from '@/services/request'
import { mapActions } from 'vuex'

// Submodales
import ModalProgramGroup from './groups/ModalProgramGroup.vue'
import ModalProgramContribution from './contributions/ModalProgramContribution.vue'
import ModalProgramBuilding from './buildings/ModalProgramBuilding.vue'
import ModalProgramCompany from './companies/ModalProgramCompany.vue'
import ModalProgramGroupAccounts from './groups/ModalProgramGroupAccount.vue'

import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    name: "modal-program",

    components: {
        ModalProgramGroup,
        ModalProgramContribution,
        ModalProgramBuilding,
        ModalProgramCompany,
        DatePicker,
        ModalProgramGroupAccounts
    },

    data() {
        return {
            errors: {},
            catalogue: new Catalogue(),

            program_id: null,
            activeTab: 'main',   // tab por defecto

            form: {
                id: '',
                name: '',
                total: '',
                program_type_id: 1,
                contributions_count: '',
                program_installments: [],
            },

            // listas relacionadas
            loading: false,
            groups: [],
            contributions: [],
            companies: [],
            properties: [],
            buildings: [],
        }
    },

    methods: {
        openGroupAccountsModal(group) {
            Event.$emit('open-group-accounts-modal', group);
        },
        open(program_id) {
            this.program_id = program_id;
            this.activeTab = 'main';
            this.loadProgram();
            this.loadRelations();
            this.$modal.show('modalEditProgram');
        },

        close() {
            this.errors = {};
            this.form = {
                id: '',
                name: '',
                total: '',
                program_type_id: 1,
                contributions_count: '',
            };
            this.$modal.hide('modalEditProgram');
        },

        /* ===========================
         *   CARGAR DATOS DEL PROGRAMA
         * =========================== */
        async loadProgram() {
            try {
                const { data } = await request.get(`/programs/${this.program_id}`);
                this.form = {
                    id: data.id,
                    name: data.name,
                    total: data.total,
                    program_type_id: data.program_type_id,
                    contributions_count: data.contributions_count,
                    program_installments: data.installments,
                };
            } catch (error) {
                console.log(error);
            }
        },

        /* ===========================
         *   CARGAR RELACIONES
         * =========================== */
        async loadRelations() {
            this.loading = true;
            try {
                const { data } = await request.get(`/programs/${this.program_id}/relations`);
                this.groups = data.groups;
                this.contributions = data.contributions;
                this.companies = data.companies;
                this.buildings = data.buildings;
                this.loading = false;
            } catch (error) {
                console.log(error);
                this.loading = false;
            }
        },

        /* ===========================
         *   GUARDAR DATOS PRINCIPALES
         * =========================== */
        async saveProgram() {
            let payload = {
                name: this.form.name,
                total: this.form.total,
                program_type_id: this.form.program_type_id,
                contributions_count: this.form.contributions_count,
                installments: this.form.program_installments,
            };

            let endpoint = `/programs/${this.program_id}`;
            payload._method = "PUT";

            try {
                let { data } = await request.post(endpoint, payload);
                this.successNotification(data.message);
                this.close();
                Event.$emit('event-load-program');
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        /* ===========================
         *   ABRIR SUBMODALES
         * =========================== */

        openGroupModal(group = null) {
            Event.$emit("event-open-program-group", group ?? { program_id: this.program_id });
        },

        openContributionModal(contribution = null) {
            Event.$emit("event-open-program-contribution", contribution ?? { program_id: this.program_id });
        },

        openCompanyModal() {
            Event.$emit("event-open-program-company", {
                program_id: this.program_id,
                assigned_companies: this.companies.map(c => c.id)
            });
        },

        openBuildingModal() {
            Event.$emit("event-open-program-property", {
                program_id: this.program_id,
                assigned_properties: this.buildings.map(p => p.id)
            });
        },

        /* ===========================
         *   ELIMINAR RELACIONES
         * =========================== */
        async deleteRelation(endpoint) {
            this.$swal({
                title: '¿Eliminar registro?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {

                if (result.isConfirmed) {
                    try {
                        let { data } = await request.destroy(endpoint);

                        this.successNotification(data.message);

                        // recargar las listas del tab
                        this.loadRelations();

                    } catch (error) {
                        this.errorNotification(error);
                    }
                }
            });

        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success'
        })
    },

    created() {
        // recargar todo cuando un submodal guarda algo
        Event.$on("event-reload-program-relations", () => {
            this.loadRelations();
        });

        // abrir modal desde cualquier parte
        Event.$on("event-edit-program", (program_id) => {
            this.open(program_id);
        });
    },
    mounted() {
        this.catalogue.getProgramsTypes();
    },
    watch: {
        'form.contributions_count': {
            immediate: true,
            handler(newVal) {
                const count = parseInt(newVal || 0, 10);

                // si está vacío o inválido, no destruyas lo capturado
                if (!count || count < 1) return;

                const current = Array.isArray(this.form.program_installments)
                    ? this.form.program_installments
                    : [];

                const next = [];

                for (let i = 1; i <= count; i++) {
                    const old = current[i - 1] || {};
                    next.push({
                        number: i,
                        amount: old.amount ?? '',     // conserva lo capturado
                        due_date: old.due_date ?? '', // conserva lo capturado
                        id: old.id ?? null            // si ya existe en BD, conserva id
                    });
                }

                // reasigna solo el arreglo “recortado/extendido”
                this.form.program_installments = next;
            }
        }
    }
}
</script>

<template>
    <modal name="modalEditProgram" :width="'90%'" :height="'90%'" :click-to-close="false">

        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="close">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <div class="modal-header">
            <h5 class="modal-title">Programa</h5>
        </div>

        <div class="modal-body">

            <!-- TABS -->
            <ul class="nav nav-pills nav-fill nav-tabs">
                <li class="nav-item"><a class="nav-link" :class="{ active: activeTab === 'main' }"
                        @click="activeTab = 'main'">Datos</a></li>
                <li class="nav-item"><a class="nav-link" :class="{ active: activeTab === 'groups' }"
                        @click="activeTab = 'groups'">Grupos</a></li>
                <li class="nav-item"><a class="nav-link" :class="{ active: activeTab === 'contributions' }"
                        @click="activeTab = 'contributions'">Aportaciones</a></li>
                <li class="nav-item"><a class="nav-link" :class="{ active: activeTab === 'companies' }"
                        @click="activeTab = 'companies'">Empresas</a></li>
                <li class="nav-item"><a class="nav-link" :class="{ active: activeTab === 'buildings' }"
                        @click="activeTab = 'buildings'">Propiedades</a></li>
            </ul>


            <!-- TAB: DATOS PRINCIPALES -->
            <div v-if="activeTab === 'main'" class="mt-4">

                <div class="row">

                    <div class="col-md-3">
                        <label>Nombre</label>
                        <input type="text" v-model="form.name" class="form-control">
                        <div class="text-danger" v-if="errors.name">{{ errors.name[0] }}</div>
                    </div>

                    <div class="col-md-3">
                        <label>Tipo de Programa</label>
                        <select class="form-control" v-model="form.program_type_id">
                            <option v-for="type in catalogue.programs_types" :key="type.id" :value="type.id">
                                {{ type.name }}
                            </option>
                        </select>
                        <div v-if="errors.program_type_id" class="text-danger">{{ errors.program_type_id[0] }}</div>
                    </div>

                    <div class="col-md-3">
                        <label>Total</label>
                        <money class="form-control" v-model="form.total"></money>
                        <div v-if="errors.total" class="text-danger">{{ errors.total[0] }}</div>
                    </div>

                    <div class="col-md-3">
                        <label>N° de aportaciones</label>
                        <input type="number" v-model="form.contributions_count" class="form-control">
                    </div>

                </div>

                <div class="row" v-if="form.program_type_id == 1">
                    <div class="col-md-12">
                        <strong>Montos por aportación</strong>
                    </div>

                    <div class="col-md-12 mt-2">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center text-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Monto</th>
                                        <th>Fecha (opcional)</th>
                                    </tr>
                                </thead>
                                <tbody v-if="form.program_installments.length > 0">
                                    <tr v-for="(it, idx) in form.program_installments" :key="idx">
                                        <td>{{ it.number }}</td>
                                        <td>
                                            <money class="form-control" v-model="form.program_installments[idx].amount">
                                            </money>
                                            <div v-if="errors[`program_installments.${idx}.amount`]"
                                                class="text-danger">
                                                {{ errors[`program_installments.${idx}.amount`][0] }}
                                            </div>
                                        </td>
                                        <td>
                                            <date-picker v-model="form.program_installments[idx].due_date"
                                                required="required" valueType="format"></date-picker>
                                            <div v-if="errors[`program_installments.${idx}.due_date`]"
                                                class="text-danger">
                                                {{ errors[`program_installments.${idx}.due_date`][0] }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3">Sin montos.</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="errors.program_installments" class="text-danger">
                                {{ errors.program_installments[0] }}

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <hr>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-warning float-left" @click="close">
                            <i class="fas fa-undo-alt"></i> Cerrar
                        </button>
                        <button class="btn btn-outline-success float-right" @click="saveProgram">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                    </div>

                </div>

            </div>


            <!-- ======================
                 TAB: GRUPOS
            ====================== -->
            <div v-if="activeTab === 'groups'" class="mt-4">

                <button class="btn btn-sm btn-outline-success mb-3 float-right" @click="openGroupModal()">
                    <i class="fa fa-plus"></i> Agregar Grupo
                </button>

                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>

                    <tbody v-if="loading">
                        <tr>
                            <td align="center" colspan="3">
                                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                <h5>Cargando</h5>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="groups.length > 0">
                        <tr v-for="g in groups" :key="g.id">
                            <td>{{ g.id }}</td>
                            <td>{{ g.name }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-info m-1" @click="openGroupModal(g)">
                                    <i class="fa fa-edit"></i> Editar
                                </button>

                                <button class="btn btn-sm btn-outline-danger m-1"
                                    @click="deleteRelation(`/programs_groups/${g.id}`)">
                                    <i class="fa fa-trash"></i> Eliminar
                                </button>

                                <button class="btn btn-sm btn-outline-primary m-1" @click="openGroupAccountsModal(g)">
                                    <i class="fa fa-university"></i> Cuentas
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td align="center" colspan="3">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <!-- ======================
                 TAB: APORTACIONES
            ====================== -->
            <div v-if="activeTab === 'contributions'" class="mt-4">

                <button class="btn btn-sm btn-outline-success mb-3 float-right" @click="openContributionModal()">
                    <i class="fa fa-plus"></i> Agregar Aportación
                </button>

                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>#</th>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>

                    <tbody v-if="loading">
                        <tr>
                            <td align="center" colspan="5">
                                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                <h5>Cargando</h5>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="contributions.length > 0">
                        <tr v-for="c in contributions" :key="c.id">
                            <td>{{ c.id }}</td>
                            <td>{{ c.number }}</td>
                            <td>{{ c.amount | toCurrency }}</td>
                            <td>{{ c.due_date | toDateTime }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-info m-1" @click="openContributionModal(c)">
                                    <i class="fa fa-edit"></i> Editar
                                </button>

                                <button class="btn btn-sm btn-outline-danger m-1"
                                    @click="deleteRelation(`/programs_additional/${c.id}`)">
                                    <i class="fa fa-trash"></i> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td align="center" colspan="5">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <!-- ======================
                 TAB: EMPRESAS
            ====================== -->
            <div v-if="activeTab === 'companies'" class="mt-4">

                <button class="btn btn-sm btn-outline-success mb-3 float-right" @click="openCompanyModal()">
                    <i class="fa fa-plus"></i> Agregar Empresa
                </button>

                <table class="table table-bordered text-center">

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="loading">
                        <tr>
                            <td align="center" colspan="3">
                                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                <h5>Cargando</h5>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="companies.length > 0">
                        <tr v-for="co in companies" :key="co.id">
                            <td>{{ co.id }}</td>
                            <td>{{ co.name }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-danger"
                                    @click="deleteRelation(`/programs_companies/${co.pivot.id}`)">
                                    <i class="fa fa-trash"></i> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td align="center" colspan="3">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <!-- ======================
                 TAB: PROPIEDADES
            ====================== -->
            <div v-if="activeTab === 'buildings'" class="mt-4">

                <button class="btn btn-sm btn-outline-success mb-3 float-right" @click="openBuildingModal()">
                    <i class="fa fa-plus"></i> Agregar Propiedad
                </button>

                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="loading">
                        <tr>
                            <td align="center" colspan="3">
                                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                <h5>Cargando</h5>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="buildings.length > 0">
                        <tr v-for="p in buildings" :key="p.id">
                            <td>{{ p.id }}</td>
                            <td>{{ p.name }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-danger"
                                    @click="deleteRelation(`/programs_buildings/${p.pivot.id}`)">
                                    <i class="fa fa-trash"></i> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td align="center" colspan="3">Sin resultados.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <!-- SUBMODALES -->
        <ModalProgramGroup />
        <ModalProgramContribution />
        <ModalProgramBuilding />
        <ModalProgramCompany />
        <ModalProgramGroupAccounts />

    </modal>
</template>

<style scoped>
.nav-tabs .nav-link.active {
    background: #214d83;
    color: white;
}

.text-danger {
    font-size: 12px;
}
</style>
